module.exports = __webpack_public_path__ + "static/media/google_maps.2aa273b5.png";